export default {
    open: true,
    title: '',
    description: '',
    actions: [],
    breadcrumbs: [],
    sx: {},
    canGoBack: false,
    goBackParams: []
};
